import { render, staticRenderFns } from "./accessTermsPopup.vue?vue&type=template&id=a031a356&scoped=true&"
import script from "./accessTermsPopup.vue?vue&type=script&lang=js&"
export * from "./accessTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./accessTermsPopup.vue?vue&type=style&index=0&id=a031a356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a031a356",
  null
  
)

export default component.exports